import { TextField } from '@calendly/form'
import { I18n } from '@calendly/i18n'


export const CancellationPolicyField = ({ showEnforcement, isLocked }) => (
  <TextField
    name="cancellationPolicy"
    disabled={showEnforcement || isLocked}
    label={I18n.t('publisher.event_types.notifications.cancellation_policy.policy_label')}
    proTip={I18n.t('publisher.event_types.notifications.cancellation_policy.policy_label_tip')}
    type="textarea"
  />
)
